import ComponentName from '@Constant/componentName'
import { MY_SAVE_MARK } from '@Constant/behaviorTrack'

const favorites = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/favorites',
    children: [
      {
        component: () => import('../../views/favorites/index.vue'),
        path: 'index',
        name: ComponentName.favorites.index,
        auth: '*',
        meta: {
          title: '收藏夹',
          logAuto: {
            pv: true,
            duration: true,
            source: MY_SAVE_MARK.PV
          }
        }
      }
    ]
  }
]

export default favorites
